import styled from 'styled-components';
import { typography } from '@atlaskit/theme';

const Body = styled.div`
  ${typography.h400};
  width: 240px;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  margin-top: -10px;
  color: inherit;
`;

const Link = styled.a`
  color: #ffffff !important;
  text-decoration: underline;
`;

export { Body, Link };
